
import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';

interface SelectionsTabProps {
  selections: any[];
  date?: Date;
}

export const SelectionsTab: React.FC<SelectionsTabProps> = ({ selections, date }) => {
  const { t } = useTranslation();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  if (selections.length === 0) {
    return (
      <div className="text-center py-6 text-muted-foreground">
        {date ? 
          t('history.noPlansDate', { date: format(date, 'dd/MM/yyyy') }) : 
          t('history.noPlans')}
      </div>
    );
  }

  return (
    <div className="max-h-[50vh] overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t('history.fields.type')}</TableHead>
            <TableHead>{t('history.fields.name')}</TableHead>
            <TableHead>{t('history.fields.price')}</TableHead>
            <TableHead>{t('history.fields.date')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {selections.map((selection: any, index: number) => (
            <TableRow key={index}>
              <TableCell>{selection.type}</TableCell>
              <TableCell>{selection.name}</TableCell>
              <TableCell>{selection.price} DJF</TableCell>
              <TableCell>{formatDate(selection.datetime)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
